export default __webpack_public_path__ + "static/media/MapImage.5ba60037.png";